export function normalizeOptionalPercentage(value) {
  return value == null || value === "" ? null : Number(value);
}
